import React from "react";
import { Link } from "react-router-dom";
import ImageHelper from "../../../Helpers/ImageHelper";
import SimpleProgressbar from "../../Utilities/SimpleProgressBar";

const AboutUsStatistics = () => {
  return (
    <section
      className="section-padding progress-area wow animated text-dark"
      style={{ visibility: "visible" }}
    >
      <div className="container">
        <div className="row py-5">
          <div className="col-md-6">
            <section className="flags">
              <h3
                className="text-left  wow fadeInDown mb-2"
                data-wow-delay="0.2"
                style={{ visibility: "visible", animationName: "fadeInDown" }}
              >
                Real Projects, Real Places
              </h3>
              <p
                className="wow fadeInDown"
                data-wow-delay="0.4s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.4s",
                  animationName: "fadeInDown",
                }}
              >
                From a hospitality SaaS platform built for a Canadian
                client, to enterprise healthcare systems shipped across
                California, to a Chrome extension built for a London-based
                Amazon seller — our founder's work has gone to production
                across North America and Europe. See the details on our{" "}
                <Link to="/case-study">Case Studies</Link> page.
              </p>

              <div
                className="row marg-btm wow fadeInDown"
                data-wow-delay="0.2s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.2s",
                  animationName: "fadeInDown",
                }}
              >
                <div className="col-md-12">
                  <br />
                  <div className="flag">
                    <img
                      draggable="false"
                      src={ImageHelper.locationMap}
                      className="img-fluid"
                      style={{ filter: "brightness(0)" }}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="col-md-6">
            <section className="progress-bars">
              <h3
                className="text-left wow fadeInDown mb-2"
                data-wow-delay="0.2s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.2s",
                  animationName: "fadeInDown",
                }}
              >
                Where Our Experience Runs Deepest
              </h3>
              <p
                className="bottom-space wow fadeInDown"
                data-wow-delay="0.4s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.4s",
                  animationName: "fadeInDown",
                }}
              >
                Hands-on experience across our core disciplines.
              </p>

              <div className="row skillbar-wraps">
                <div className="col-lg-12 skill-right">
                  <div className="single-skill">
                    <p>PRODUCT &amp; UX DESIGN 95%</p>
                    <SimpleProgressbar endValue="95" />
                  </div>
                  <div className="single-skill">
                    <p>FRONTEND ENGINEERING (REACT) 90%</p>
                    <SimpleProgressbar endValue="90" />
                  </div>
                  <div className="single-skill">
                    <p>DESIGN SYSTEMS 85%</p>
                    <SimpleProgressbar endValue="85" />
                  </div>
                  <div className="single-skill">
                    <p>HEALTHCARE &amp; ENTERPRISE PLATFORMS 85%</p>
                    <SimpleProgressbar endValue="85" />
                  </div>
                  <div className="single-skill">
                    <p>EDTECH &amp; HR TECH 80%</p>
                    <SimpleProgressbar endValue="80" />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsStatistics;
